'use strict';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const supportedKinds = [
    'recaptchaCaptcha'
];
const parseFormieCaptchas = (captchas)=>{
    return captchas.reduce((acc, captcha)=>{
        var _captcha_handle;
        const handle = (_captcha_handle = captcha.handle) != null ? _captcha_handle : '';
        if (!supportedKinds.includes(handle)) return acc;
        var _captcha_name, _captcha_value;
        return _extends({}, acc, {
            [handle]: {
                handle,
                name: (_captcha_name = captcha.name) != null ? _captcha_name : '',
                value: (_captcha_value = captcha.value) != null ? _captcha_value : ''
            }
        });
    }, {});
};

module.exports = parseFormieCaptchas;
